import React, { useContext, useEffect, useState } from "react";
import Image from "next/image";
import Router from "next/router";
import Head from "next/head";
import CatergoryCard from "./CatergoryCard";
import { CategoryContainer, CategoryHeader, Content } from "./style";
import { categories } from "../options";
import { MultiSelectFormContext } from "~/contexts/MultiSelectForm";
import Briefing from "../Briefing";
import SubCategoryForm from "../CategoryForm/SubCategoryForm";
import { MarketPlaceCreationJob } from "~/contexts/MultiSelectForm/types";
import WarningModal from "../WarningModal";
import useAuth from "~/hooks/useAuth";
import Panel from "~/shared/Panel";
import { Row, Col } from "react-bootstrap";

type CategoryFormProps = {
    nextStep?: () => void;
    goToStep?: (step: number) => void;
};

const CategoryForm = ({ nextStep, goToStep }: CategoryFormProps) => {
    const { account } = useAuth();
    const { values, handleChange, setValues, clearLocalStorageSteps, openWarningModal, setOpenWarningModal } =
        useContext(MultiSelectFormContext);

    const redirectFn = () => {
        clearLocalStorageSteps(["addressAndDate", "confirmation", "briefing_step", "values", "totalSteps", "redirect"]);

        if (account) {
            return Router.push("/dashboard");
        }

        Router.push("/");
    };

    useEffect(() => {
        const confirmationStep = Number(localStorage.getItem("confirmation"));
        const localValues: MarketPlaceCreationJob = JSON.parse(localStorage.getItem("values"));

        const currentStep = confirmationStep ? confirmationStep : 1;

        const params = new URLSearchParams(window.location.search);
        params.set("step", currentStep.toString());

        const categoryId = params.get("segmentId");

        window.history.pushState({ step: currentStep }, "", `/marketplace/book?${params.toString()}`);
        if (categoryId) {
            handleChange("category", parseInt(categoryId));
        }

        if (localValues?.category) {
            handleChange("category", localValues.category);
            setValues(localValues);
        }
    }, []);

    useEffect(() => {
        const confirmationStep = Number(localStorage.getItem("confirmation"));
        const totalSteps = Number(localStorage.getItem("totalSteps"));

        if (confirmationStep && confirmationStep !== totalSteps - 1) {
            clearLocalStorageSteps(["confirmation", "values", "addressAndDate", "briefing_step", "redirect"]);
        }
    }, []);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [values.category]);

    return (
        <>
            <Head>
                <title>Solicitar fotógrafo - Fotop Serviços</title>
            </Head>
            <WarningModal
                isOpen={openWarningModal}
                onHide={() => setOpenWarningModal(false)}
                redirectFn={redirectFn}
                owner={account?.organization.owner}
            />
            <Row>
                <Col lg={{ span: 4, order: "first" }} md={{ span: 12, order: "last" }}>
                    <Panel className="title-header">
                        <div className="title-img">
                            <Image
                                src="/images/slide-show-1.jpg"
                                alt="visualizando uma tela para agendamento"
                                layout="responsive"
                                width={300}
                                height={244}
                            />
                        </div>
                        <div className="title-text">
                            <br />
                            <strong style={{ fontSize: "1.25rem", lineHeight: "2rem" }}>
                                Precisando de um fotógrafo?
                            </strong>
                            <p>Conheça o Novo Marketplace do Fotop Serviços!</p>
                            <br />
                            <p>
                                Selecione o tipo de fotos e receba propostas de mais de 15 mil fotógrafos profissionais
                                cadastrados em nossa plataforma.
                            </p>
                            <br />
                            <p>
                                Receba propostas de valores, veja seus portfólios, troque mensagens e contrate o que
                                melhor atende a sua necessidade.
                            </p>
                            <br />
                            <strong>
                                Rápido, prático e seguro!
                                <br />
                                Solicite um orçamento agora mesmo!
                            </strong>
                            <br />
                            <br />
                            <p>
                                Dúvidas? Entre em{" "}
                                <a
                                    href="https://wa.me/5511988721831?text=Ol%C3%A1,%20queria%20mais%20informa%C3%A7%C3%B5es%20sobre%20o%20marketplace"
                                    target="_blank"
                                    rel="noopener nofollow"
                                    style={{ color: "inherit" }}
                                >
                                    contato
                                </a>{" "}
                                ou veja nosso{" "}
                                <a
                                    href="https://fotop.com/fotos/r/Wb47nz"
                                    target="_blank"
                                    rel="noopener nofollow"
                                    style={{ color: "inherit" }}
                                >
                                    FAQ
                                </a>
                                .
                            </p>
                        </div>
                    </Panel>
                </Col>
                <Col lg={{ span: 8, order: "last" }} xs={{ span: 12, order: "first" }}>
                    {!values.category || values.category === 0 ? (
                        <>
                            <CategoryHeader>
                                <h1>Qual o tipo de sessão fotográfica que deseja?</h1>
                            </CategoryHeader>
                            <Row>
                                {categories.map((category) => (
                                    <Col lg={4} xs={6} className="align-items-center">
                                        <CatergoryCard
                                            key={category.id}
                                            name={category.name}
                                            src={category.img}
                                            sources={category.srcs}
                                            category={category}
                                            chooseCategory={handleChange}
                                            active={values?.category === category.id ? "active" : ""}
                                        />
                                    </Col>
                                ))}
                            </Row>
                        </>
                    ) : (
                        ""
                    )}

                    {values?.category === 7 ? <SubCategoryForm /> : ""}
                    {values?.category ? <Briefing nextStep={nextStep} goToStep={goToStep} /> : ""}
                </Col>
            </Row>
            <Row>
                <Col>
                    <Panel className="business-link">
                        <p>
                            <strong>Você tem uma empresa?</strong>{" "}
                            Cuidamos de sua operação de fotos,{" "}
                            <a target="_blank" href="https://faq.fotop.com/portal/pt-br/kb/articles/faq-fotop-servi%C3%A7os-business-b2b">saiba mais aqui!</a>
                        </p>
                    </Panel>
                </Col>
            </Row>
        </>
    );
};

export default CategoryForm;
